if (window.matchMedia("(max-width: 767px)").matches) {
  /* _________________ MOBILE TABS _________________ */
  let tabs = document.querySelectorAll('.tabs__tab');
  tabs.forEach(function (tab) {
    tab.addEventListener('click', function () {
      let tabId = tab.getAttribute('data-tab');
      console.log("tab id : ", tabId);

      // TAB
      // Change the active tab
      let activeTab = tab.closest('.tabs__tabs-items').querySelector('.tabs__tab--is-active');
      activeTab.classList.remove('tabs__tab--is-active');
      tab.classList.add('tabs__tab--is-active');

      // TEXT
      // Change the text of the active tab
      let tabText = tab.closest('.tabs__tabs-container').querySelector(`.tabs__text[data-tab-text="${tabId}"]`);
      if (tabText) {
        let activeTabText = tab.closest('.tabs__tabs-container').querySelector('.tabs__text--is-active');
        activeTabText.classList.remove('tabs__text--is-active');
        tabText.classList.add('tabs__text--is-active');
      }

      // CONTENT 
      // hide the tab content of the previous active tab
      let activeTabContent = tab.closest('.tabs__tabs-container').querySelector('.tab-content--is-active');
      console.log('active tab content : ', activeTabContent);
      activeTabContent.classList.remove('tab-content--is-active');

      // get the tab content corresponding to the clicked tab
      let tabContent = tab.closest('.tabs__tabs-container').querySelector(`.tab-content[data-tab-content="${tabId}"]`);
      tabContent.classList.add('tab-content--is-active');

      // Scroll to the top of the tab container to avoid unexpected scroll behavior
      const tabContainer = document.querySelector('.mobile .tabs__tabs-container');
      window.scrollTo({
        top: tabContainer.offsetTop - 50,
        behavior: 'instant' // "instant" value, is for blocking the basic scroll behavior style which is "scroll" (in main.scss)
      });
    });
  });
} else {
  /* _________________ DESKTOP TABS _________________ */
  // Highlight the right anchor when use scroll to the content

  let desktopTabs = document.querySelectorAll('.desktop .tabs__tab-item');
  let visibleEntry = [];
  let observer = new IntersectionObserver(entries => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        visibleEntry[entry.target.id] = entry;
      } else {
        delete visibleEntry[entry.target.id];
      }
    });

    // Sort visible entries by intersectionRatio
    const sortedEntries = Object.values(visibleEntry).sort((a, b) => b.intersectionRatio - a.intersectionRatio);
    console.log("sorted entries : ", sortedEntries);

    // Find the corresponding title to apply the active style
    if (sortedEntries.length > 0) {
      const tabId = sortedEntries[0].target.id;
      const newActiveTab = document.querySelector('.desktop .tabs__tabs-container').querySelector(`[data-tab="${tabId}"]`);
      document.querySelector('.desktop .tabs__tab--is-active').classList.remove('tabs__tab--is-active'); // Remove active class on the current active tab
      newActiveTab.classList.add('tabs__tab--is-active'); // Add active class on the title corresponding to the tab in the viewport
    }
  }, {
    rootMargin: '0px'
    //threshold: 0 // 60% of the tab must be visible to trigger the observer
  });

  // For each tab, apply the IntersectionObserver
  desktopTabs.forEach(tab => {
    observer.observe(tab);
  });
}